import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useAuth } from '@/context/AuthContext'
import { useNavigateToUnauthorized } from '@/hooks/useCustomNavigate'

import { WithAuth } from '../../hoc/WithAuth'

// prazdna stranka s presmerovaním a autorizaci. Prime volaní stranky /Steps/1?newPoleas=1
// z hlavniho menu nefungovalo vzdy spravne
const PoleasNewPageComponent = () => {

  const navigate = useNavigate()
  const navigateToUnauthorized = useNavigateToUnauthorized()
  const { user, isLoggingOut } = useAuth()

  useEffect(() => {
    if (isLoggingOut) return

    if (!user?.poleas?.poleasEnabled)
      navigateToUnauthorized('User does not have enabled Poleasing.')
    else if (!user?.poleas?.enableImport)
      navigateToUnauthorized('User does not have enabled Poleasing import.')
    else {
      navigate('/Steps/1?newPoleas=1')
    }
  }, [isLoggingOut, navigate, navigateToUnauthorized, user])

  return (<></>)
}

export const PoleasNewPage = WithAuth(PoleasNewPageComponent)